const DIGITIZE_PAGES = [
  {
    label: 'Digitize',
    value: 'digitize',
    path: 'media-digitizing-service',
  },
  {
    label: 'Tape Transfer',
    value: 'tapeTransfer',
    path: 'convert-vhs-tapes-to-digital-dvd',
  },
  {
    label: 'Audio Transfer',
    value: 'audioTransfer',
    path: 'convert-cassette-to-cd',
  },
  {
    label: 'Film transfer',
    value: 'filmTransfer',
    path: 'transfer-8mm-film-to-digital-dvd',
  },
  {
    label: 'Digital Transfer',
    value: 'digitalTransfer',
    path: 'dvd-to-digital-service',
  },
  {
    label: 'Photo Scan',
    value: 'photoScan',
    path: 'photo-scanning-service',
  },
  {
    label: 'Digitize editor',
    value: 'digitizeEditor',
    path: 'digitize-editor',
  },
  {
    label: 'Tape Transfer editor',
    value: 'tapeTransferEditor',
    path: 'digitize-editor?typeProduct=tape_transfer',
  },
  {
    label: 'Audio Transfer editor',
    value: 'audioTransferEditor',
    path: 'digitize-editor?typeProduct=audio_transfer',
  },
  {
    label: 'Film transfer editor',
    value: 'filmTransferEditor',
    path: 'digitize-editor?typeProduct=film_transfer',
  },
  {
    label: 'Digital Transfer editor',
    value: 'digitalTransferEditor',
    path: 'digitize-editor?typeProduct=digital_transfer',
  },
  {
    label: 'Photo Scan editor',
    value: 'photoScanEditor',
    path: 'digitize-editor?typeProduct=photo_scan',
  },
];
const ENHANCE_PAGES = [
  {
    label: 'Enhance',
    value: 'enhance',
    path: 'restore-retouch-photo-service',
  },
  {
    label: 'Photo Restoration',
    value: 'photoRestoration',
    path: 'old-photo-restoration',
  },
  {
    label: 'Photo Colorization',
    value: 'photoColorization',
    path: 'colorize-black-and-white-photos',
  },
  {
    label: 'Photo Retouching',
    value: 'photoRetouching',
    path: 'photo-retouching-service',
  },
  {
    label: 'Enhance wizard',
    value: 'enhanceEditor',
    path: 'enhance-editor',
  },
  {
    label: 'Photo Restoration',
    value: 'photoRestorationEditor',
    path: 'enhance-editor?typeProduct=photo_restoration',
  },
  {
    label: 'Photo Colorization',
    value: 'photoColorizationEditor',
    path: 'enhance-editor?typeProduct=photo_colorization',
  },
  {
    label: 'Photo Retouching',
    value: 'photoRetouchingEditor',
    path: 'enhance-editor?typeProduct=photo_retouching',
  },
];
const CREATE_PAGES = [
  {
    label: 'Create',
    value: 'create',
    path: 'create-photo-art',
  },
  {
    label: 'Create editor',
    value: 'photoArtEditor',
    path: 'photo-art-editor',
  },
  {
    label: 'ForeverCloud',
    value: 'foreverCloud',
    path: 'forever-cloud',
  },
];
const OTHER_PAGES = [
  {
    label: 'How it works',
    value: 'howItWorks',
    path: 'how-digitizing-and-enhancing-works',
  },
  {
    label: 'Reviews',
    value: 'reviews',
    path: 'reviews',
  },
  {
    label: 'Mission',
    value: 'mission',
    path: 'our-team',
  },
  {
    label: 'Gift Card',
    value: 'giftCard',
    path: 'gift-cards',
  },
  {
    label: 'Blog',
    value: 'blog',
    path: 'blog',
  },
  {
    label: 'Terms and Conditions',
    value: 'termsAndConditions',
    path: 'terms-and-conditions',
  },
  {
    label: 'Privacy Policy',
    value: 'privacyPolicy',
    path: 'privacy-policy',
  },
  {
    label: 'Boca Raton frame shop',
    value: 'bocaRatonFrameStoreGiftShop',
    path: 'boca-raton-frame-store-gift-shop',
  },
  {
    label: 'South Florida Media Digitizing',
    value: 'southFloridaMediaDigitizingService',
    path: 'south-florida-media-digitizing-service',
  },
  {
    label: 'South Florida Tape Transfer',
    value: 'southFloridaTapeTransfer',
    path: 'south-florida-vhs-tape-transfer-service',
  },
  {
    label: 'South Florida Film Transfer',
    value: 'southFloridaFilmTransfer',
    path: 'south-florida-film-transfer-service',
  },
  {
    label: 'South Florida Audio Transfer',
    value: 'southFloridaAudioTransfer',
    path: 'south-florida-cassette-conversion-service',
  },
  {
    label: 'South Florida Photo Scanning',
    value: 'southFloridaPhotoScanning',
    path: 'south-florida-old-photo-scanning-service',
  },
  {
    label: 'Home page',
    value: '/',
    path: '/',
  },
  {
    label: 'Cart',
    value: 'checkout',
    path: 'checkout',
  },
  {
    label: 'Cart Digitize',
    value: 'checkoutDigitize',
    path: 'checkout?main=digitize',
  },
  {
    label: 'Cart Create',
    value: 'checkoutCreate',
    path: 'checkout?main=create',
  },
  {
    label: 'Cart Restore',
    value: 'checkoutRestore',
    path: 'checkout?main=restore',
  },
  {
    label: 'Login',
    value: 'payment/login',
    path: 'payment/login',
  },
  {
    label: 'Login Digitize',
    value: 'payment/loginDigitize',
    path: 'payment/login?main=digitize',
  },
  {
    label: 'Login Create',
    value: 'payment/loginCreate',
    path: 'payment/login?main=create',
  },
  {
    label: 'Login Restore',
    value: 'payment/loginRestore',
    path: 'payment/login?main=restore',
  },
  {
    label: 'Checkout',
    value: 'payment/checkout',
    path: 'payment/checkout',
  },
  {
    label: 'Checkout Digitize',
    value: 'payment/checkoutDigitize',
    path: 'payment/checkout?main=digitize',
  },
  {
    label: 'Checkout Create',
    value: 'payment/checkoutCreate',
    path: 'payment/checkout?main=create',
  },
  {
    label: 'Checkout Restore',
    value: 'payment/checkoutRestore',
    path: 'payment/checkout?main=restore',
  },
];
const ACCOUNT_PAGES = [
  {
    label: 'My account',
    value: 'account',
    path: 'account',
  },
  {
    label: 'Shared Landing Page',
    value: 'shareMedia',
    path: 'share-media',
  },
  {
    label: 'Customer Back End Create Page',
    value: 'accountCreate',
    path: 'account?main=create',
  },
  {
    label: 'After Proof Approval POP-UP',
    value: 'accountAfterApprove',
    path: 'account?afterApprove=true',
  },
  {
    label: 'My cloud',
    value: 'accountMyFiles',
    path: 'account?main=myFiles',
  },
  {
    label: 'My proofs',
    value: 'accountProofs',
    path: 'account?main=proofs',
  },
  {
    label: 'My orders',
    value: 'accountOrderDetails',
    path: 'account?main=orderDetails',
  },
  {
    label: 'Make art',
    value: 'accountMakeArt',
    path: 'account?main=createWizard',
  },
  {
    label: 'My messages',
    value: 'accountMyMessage',
    path: 'account?main=my-message',
  },
  {
    label: 'Contact',
    value: 'contact',
    path: 'contact',
  },
];

const POD_PAGES = [
  {
    label: 'Pod',
    value: 'pod',
    path: 'pod',
  },
  {
    label: 'Print on Demand',
    value: 'printOnDemand',
    path: 'print-on-demand',
  },
];

const OPTIONS = {
  digitize: {
    title: 'Digitize',
    key: 'digitize',
    options: DIGITIZE_PAGES,
  },
  enhance: {
    title: 'Enhance',
    key: 'enhance',
    options: ENHANCE_PAGES,
  },
  create: {
    title: 'Create',
    key: 'create',
    options: CREATE_PAGES,
  },
  commercial: {
    title: 'Commercial',
    key: 'pod',
    options: POD_PAGES,
  },
  other: {
    title: 'Other',
    key: 'other',
    options: OTHER_PAGES,
  },
  account: {
    title: 'Account',
    key: 'account',
    options: ACCOUNT_PAGES,
  },
};
const ALL_PAGE_KEYS = [
  ...DIGITIZE_PAGES,
  ...ENHANCE_PAGES,
  ...CREATE_PAGES,
  ...OTHER_PAGES,
  ...ACCOUNT_PAGES,
  ...POD_PAGES,
];

export default {
  OPTIONS,
  ALL_PAGE_KEYS,
};
